import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharingComponent } from './sharing.component';
import { FormsModule }   from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, SharedModule],
    declarations: [SharingComponent],
    exports: [SharingComponent]
})

export class SharingModule { }
